import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Review } from '@models/performance/review.model';

@Component({
    selector: 'app-form-review-summary',
    templateUrl: './review-summary.template.html',
})
export class ReviewSummaryForm extends BaseForm {
    @Input() review: Review;
    @Input() participants: Map<number, boolean>;

    getParticipantCount(): number {
        return Array.from(this.participants).filter(([_, selected]) => selected).length;
    }
}
